import React, {FC, PropsWithChildren, useMemo} from 'react';

import {LinkNavigationContext} from '../../../../libs/shared/ui/src/components/links/linkNavigationContext';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {pushPathAction} from '../../../store/panels/app/appPanelRouteActions';
import {getFirstAppPanelId} from '../../../store/panels/panelsSelectors';

export const LinkNavigationProvider: FC<PropsWithChildren> = ({children}) => {
  const dispatch = useAppDispatch();
  const value = useMemo(
    () => ({
      handleLinkNavigation: (href: string) => {
        // TODO: Find a better way to get a panel ID in here.
        dispatch((dispatchParam, getState) => {
          const appPanelId = getFirstAppPanelId(getState());
          dispatchParam(pushPathAction(appPanelId, href));
        });
      },
    }),
    [dispatch],
  );

  return <LinkNavigationContext.Provider value={value}>{children}</LinkNavigationContext.Provider>;
};
